import React from 'react';

import { Link, useNavigate } from "react-router-dom";


import Button from '../components/Button';
import Input from '../components/Input';
import Text from '../components/Text';
import Panel from '../components/Panel';
import Avatar from '../components/Avatar';

function Components(props) {
    return (
        <div className='container-fluid bg-blue-lte'>

            <div class="row">
                <div class="col">
                    <h1 class="title">#Buttons</h1>
                    <div class="w-row">
                        <Text text="Starting point" classes="w-text-green-light" />
                        <Link to="/splashscreen">
                            <Button text="Let's Go !" classes="w-btn-white" />
                        </Link>

                    </div>
                    <div class="w-row">
                        <Text text="w-text w-btn-white" />
                        <Button text="Nouvelle partie" classes="w-btn-white" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text w-btn-blue" />
                        <Button text="Les WOrders (50)" classes="w-btn-blue" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text w-btn-gray" />
                        <Button text="Quitter" classes="w-btn-gray" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text w-btn-blue-s" />
                        <Button text="Suivant" classes="w-btn-blue-s" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text w-text-gray-s" />
                        <Button text="Retour" classes="w-btn-gray-s" />
                    </div>

                    <h1 class="title">#Typographie</h1>
                    <div class="w-row">
                        <Text text="w-text-white" />
                        <Text text="Word’In progress ..." classes="w-text-white" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-blue-l" />
                        <Text text="Se connecter" classes="w-text-blue-l" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-blue-xxl" />
                        <Text text="B" classes="w-text-blue-xxl" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-blue-xl" />
                        <Text text="1" classes="w-text-blue-xl" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-gray-l" />
                        <Text text="Prêt pour un WordIn ? " classes="w-text-gray-l" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-black-m" />
                        <Text text="Un text normal" classes="w-text-black-simple " />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-black-simple " />
                        <Text text="Nouvelle connexion" classes="w-text-black-m" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-green-bold" />
                        <Text text="En ligne : 250" classes="w-text-green-bold" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-blue-l" />
                        <Text text="Se connecter" classes="w-text-blue-l" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-gray-m" />
                        <Text text="Temps mis : 2 min 60 s" classes="w-text-gray-m" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-blue-m" />
                        <Text text="Rang : 3 ème" classes="w-text-blue-m" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-red-m" />
                        <Text text="Mauvaises réponses : 4" classes="w-text-red-m" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-green-light" />
                        <Text text="w-text-green-light" classes="w-text-green-light" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-black-bolder" />
                        <Text text="Points : 235220 pts" classes="w-text-black-bolder" />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-gray-paragraph" />
                        <Text
                            text="
                            L’émergence ici c’est l’émulsion, c’est pas l’immersion donc la
 cosmogonisation à forciori, parvient à gérer la renaissance 
africaine off-shore, tu sais ça. Pour emphysiquer l'animalcul
isme, la délégation vers ce qu’on appelle la dynamique des s
ports continue à incristaliser une position axisienne vers l'h
umanisme, bonnes fêtes. Pour emphysiquer l'animalculisme
, la congolexicomatisation de toute la République Démocrati
que du Congo pousse à réglementer une kermesse dans la s
ous-régionalité, mais oui. 
"
                            classes="w-text-gray-paragraph"
                        />
                    </div>
                    <div class="w-row">
                        <Text text="w-text-blue-title" />
                        <Text text="A propos" classes="w-text-blue-title" />
                    </div>

                </div>
                <div class="col">
                    <h1 class="title">#Input</h1>
                    <div class="w-row">
                        <Text text="w-input" />
                        <Input text="Nouvelle partie" type="email" placeholder="Email" classes="w-input" />
                    </div>
                    <div class="w-row">
                        <Text text="w-input-sm" />
                        <Input text="Nouvelle partie" type="email" placeholder="Nom de Femme/Fille" classes="w-input-sm" />
                    </div>
                    <h1 class="title">#Panel</h1>
                    <div class="w-row">
                        <Text text="w-panel" />
                    </div>
                    <div class="w-row">
                        <Panel text="Femme/Fille" placeholder="Nom de Femme/Fille" src="/img/players/player_d.png" classes="w-panel bg-yellow-lte card" />
                    </div>

                    <h1 class="title">#Avatar</h1>
                    <div class="w-row">
                        <Text text="w-avatar-sm" />
                        <Avatar
                            type="w-avatar-sm"
                            nom="David"
                            src="/img/players/player_d.png"
                            classes="w-avatar-sm bg-blue-semi-lte"
                        />
                    </div>
                    <div class="w-row">
                        <Text text="w-avatar-lg" />
                        <Avatar
                            type="w-avatar-lg"
                            nom="David"
                            worder="1"
                            text="53200pts"
                            src="/img/players/player_d.png"
                            classes="w-avatar-lg bg-blue-semi-lte"
                        />
                    </div>
                    <div class="w-row">
                        <Text text="w-avatar-info" />
                        <Avatar
                            type="w-avatar-info"
                            nom="David"
                            mail="david.st@word.in"
                            worder="WOrder : 30"
                            src="/img/players/player_d.png"
                            classes="w-avatar-info"
                        />
                    </div>
                    <div class="w-row">
                        <Text text="w-avatar-xl" />
                        <Avatar
                            type="w-avatar-xl"
                            nom="Hey David !"
                            text="Prêt pour un WordIn ? "
                            src="/img/players/player_d.png"
                            classes="w-avatar w-avatar-xl"
                        />
                    </div>
                    <h1 class="title">#Image</h1>
                    <div class="w-row">
                        <Text text="w-img-xl" />
                        <img className="w-img-xl" src="/img/categories/login.png" alt="login" />
                    </div>

                    <div class="w-row">
                        <Text text="w-img-lg" />
                        <img className="w-img-lg" src="/img/categories/wordin_white.png" alt="login" />
                    </div>
                </div>

            </div>



        </div>
    );
}

export default Components;